
import Hero from '~/components/blog/category/Hero'
import ArticleCard from '~/components/shared/ArticleCard'
import GetYourGuideBottom from '~/components/shared/GetYourGuideBottom'
export default {
  name: 'BlogCategory',
  components: { GetYourGuideBottom, ArticleCard, Hero },
  layout: 'noheader',
  async asyncData({ $psgChunkArray, $axios }) {
    const posts = await $axios.$get(
      `https://api.plantssogood.com/wp-json/wp/v2/posts?per_page=100&status=publish&page=1&categories=76&acf_format=standard`
    )
    return {
      posts: $psgChunkArray(posts, 3),
    }
  },
  head() {
    const title = `Cooking Tips & Tricks | ${this.$config.siteTitle}`
    const description =
      'Here you’ll find a collection of plant-based cooking tips and tricks to help you cook better plant-based meals at home.'
    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/blog/cooking-tips-og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/blog/cooking-tips-og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
